/**
 *  消息强通知功能
 *
 */
angular.module('messageNotifyModule', []).directive('messageNotifyBox', [
    '$timeout',
    'trsHttpService',
    'localStorageService',
    '$q',
    '$state',
    '$sessionStorage',
    function($timeout, trsHttpService, localStorageService, $q, $state, $sessionStorage) {
        return {
            restrict: 'E',
            replace: true,
            scope: true,
            templateUrl: './messageNotify/message_notify_tpl.html',
            link(scope, $element, $attrs) {
                initStatus();
                initData();

                /**
                 * [initStatus description] 初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    scope.status = {
                        noticeInfo: {},
                        timer: '',
                        title: '消息通知',
                        closetimer: '',
                        closeTime: 5000,
                    };
                    scope.isShowWindow = false;
                    scope.data = {};
                    scope.notifyTimer = null;
                }

                /**
                 * [hideWindow description] 关闭窗口
                 * @return {[type]} [description]
                 */
                function hideWindow() {
                    scope.status.closetimer = setTimeout(() => {
                        closeWindow();
                    }, scope.status.closeTime);
                }

                /**
                 * [closeWindow 立即关闭窗口]
                 *
                 * @return  {[type]}
                 *   [return description]
                 */
                function closeWindow() {
                    $sessionStorage.cookie.set('reportDeadlineNotify', JSON.stringify(scope.data), 0.25);
                    scope.isShowWindow = false;
                    scope.status.noticeInfo = {};
                    clearTimeout(scope.status.closetimer);
                }

                /**
                 * [initData description] 初始化数据
                 * @return {[type]} [description]
                 */
                function initData() {
                    getData().then(function(data) {
                        $sessionStorage.cookie.set('reportDeadlineNotify', JSON.stringify(data), 0.25);
                        startNotify();
                    });
                }

                /**
                 * [startNotify 开始弹出消息通知]
                 *
                 * @return  {[type]}
                 *   [return description]
                 */
                function startNotify() {
                    let notifyTapTime = 30000;
                    scope.data = $sessionStorage.cookie.get('reportDeadlineNotify');
                    if (scope.data.datas.length) {
                        let message = scope.data.datas.shift();
                        scope.status.noticeInfo = message;
                        showWindow();
                        hideWindow();
                        scope.status.timer = setTimeout(function() {
                            startNotify();
                            scope.$apply();
                        }, notifyTapTime);
                    } else {
                        clearTimeout(scope.status.timer);
                    }
                }

                /**
                 * [getData 获取选题交稿通知]
                 *
                 * @return  {[type]}
                 *   [return description]
                 */
                function getData() {
                    let defer = $q.defer();
                    let messageData = $sessionStorage.cookie.get('reportDeadlineNotify');
                    if (messageData) {
                        defer.resolve(messageData);
                    } else {
                        let params = {
                            serviceid: 'select',
                            method: 'findTodayUnboundTopic',
                        };
                        trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, 'GET').then(function(data) {
                            defer.resolve(data);
                        });
                    }
                    return defer.promise;
                }

                /**
                 * [stopDisplay description] 阻止浮窗消失
                 * @return {[type]} [description]
                 */
                scope.stopDisplay = function() {
                    clearTimeout(scope.status.closetimer);
                };

                /**
                 * [goOnDisplay description] 继续消失
                 * @return {[type]} [description]
                 */
                scope.goOnDisplay = function() {
                    if (scope.status.closetimer) {
                        clearTimeout(scope.status.closetimer);
                        scope.status.closetimer = null;
                    }
                    hideWindow();
                };

                /**
                 * [close description] 关闭浮框
                 * @return {[type]} [description]
                 */
                scope.close = function() {
                    closeWindow();
                };

                /**
                 * [showWindow description] 显示窗口
                 * @return {[type]} [description]
                 */
                function showWindow() {
                    scope.isShowWindow = true;
                }

                scope.goReportDeatail = function() {
                    let message = scope.status.noticeInfo;
                    localStorageService.set('newPlanRoter', 'paperTopic/TopicCollect');
                    localStorageService.set('newPlanParam', JSON.stringify(message));
                    $state.go('front.newplanning', {}, {});
                };
            },
        };
    },
]);
